import { useTranslation } from 'react-i18next';

const benefits = [
  { icon: 'ri-shield-check-line', titleKey: 'integrated.quality.title', descKey: 'integrated.quality.desc' },
  { icon: 'ri-cpu-line', titleKey: 'integrated.stability.title', descKey: 'integrated.stability.desc' },
  { icon: 'ri-flow-chart', titleKey: 'integrated.supply.title', descKey: 'integrated.supply.desc' },
  { icon: 'ri-coins-line', titleKey: 'integrated.price.title', descKey: 'integrated.price.desc' },
];

export default function IntegratedSupply() {
  const { t } = useTranslation('supplierNetwork');

  return (
    <section className="w-full bg-white py-12 md:py-16 lg:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 md:mb-14">
            <span className="text-xs font-semibold text-warm-500 uppercase tracking-[0.2em] mb-3 block">
              {t('integrated.label')}
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-ink-700 mb-4">
              {t('integrated.title')}
            </h2>
            <p className="text-sm md:text-base text-ink-400 max-w-2xl mx-auto">
              {t('integrated.subtitle')}
            </p>
          </div>

          {/* Benefits grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {benefits.map((item) => (
              <div
                key={item.titleKey}
                className="p-6 md:p-7 bg-cream-50 border border-ink-100 rounded-xl hover:border-warm-400/40 transition-colors"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-warm-50 flex items-center justify-center mb-4">
                  <i className={`${item.icon} text-warm-500 text-xl md:text-2xl`} />
                </div>
                <h3 className="text-base md:text-lg font-semibold text-ink-700 mb-2">
                  {t(item.titleKey)}
                </h3>
                <p className="text-xs md:text-sm text-ink-400 leading-relaxed">
                  {t(item.descKey)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}